'use client';

import { useEffect } from 'react';

export default function TrackingStorageManager() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const urlParams = new URLSearchParams(window.location.search);

    // Store data for 30 days = 30 * 24 * 60 * 60 * 1000 ms
    const TTL = 30 * 24 * 60 * 60 * 1000;
    // const TTL = 5 * 1000; // 5 seconds

    const setWithExpiry = (key: string, value: string, ttl: number) => {
      const now = Date.now();

      const item = {
        value,
        expiry: now + ttl,
      };

      localStorage.setItem(key, JSON.stringify(item));
    };

    const getWithExpiry = (key: string) => {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) return null;

      const item = JSON.parse(itemStr);
      const now = Date.now();

      if (now > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }

      return item.value;
    };

    // If any utm_ query params are present and not ONLY utm_nitro,
    // purge existing utm_* keys (except utm_nitro). If only utm_nitro is present, keep existing utm_ values.
    const utmQueryKeys = Array.from(urlParams.keys()).filter((key) =>
      key.startsWith('utm_'),
    );
    const hasUtmInQuery = utmQueryKeys.length > 0;
    const hasOnlyUtmNitro =
      utmQueryKeys.length === 1 && utmQueryKeys[0] === 'utm_nitro';

    if (hasUtmInQuery && !hasOnlyUtmNitro) {
      Object.keys(localStorage).forEach((localKey) => {
        if (localKey.startsWith('utm_') && localKey !== 'utm_nitro') {
          localStorage.removeItem(localKey);
        }
      });
    }

    urlParams.forEach((value, key) => {
      if (
        key.startsWith('ref_') ||
        key.startsWith('afc_') ||
        key.startsWith('utm_')
      ) {
        const existing = getWithExpiry(key);

        if (existing) {
          // Update the value but refresh expiry
          setWithExpiry(key, value, TTL);
        } else {
          // Create new value
          setWithExpiry(key, value, TTL);
        }
      }
    });
  }, []);

  return null;
}
